import { useState, useEffect, useRef } from 'react';
import { fmtDate } from '../events/util';

const API = process.env.REACT_APP_API_URL || '';
const SEG = ['#8B0F1A', '#C8102E', '#4A0810', '#A8101F', '#6B0F1A', '#E63946'];

export default function RoulettePopup({ eventId }) {
  const [cfg, setCfg] = useState(null);
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  // Desmarcada por defecto y opcional: girar la ruleta no obliga a aceptar novedades.
  const [optin, setOptin] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');
  const [rot, setRot] = useState(0);
  // '' | 'yendo' | 'ok' | <mensaje de error>. El cupón llega por mail, así que el
  // "no me llegó" es parte del premio: sin esto, un mail en spam es un premio perdido.
  const [reenvio, setReenvio] = useState('');

  async function reenviar() {
    setReenvio('yendo');
    try {
      const r = await fetch(`${API}/api/public/roulette/resend`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event_id: eventId, email }),
      });
      const d = await r.json().catch(() => ({}));
      setReenvio(r.ok ? 'ok' : (d.error || 'No se pudo reenviar'));
    } catch { setReenvio('No se pudo reenviar'); }
  }
  // La marca se ata al evento VINCULADO a la ruleta, no a la página: si la persona ya
  // jugó por CALIENTE, no tiene que volver a verla aunque entre por otro evento
  // publicado — y cuando el dueño vincule la ruleta a un evento nuevo, reaparece sola.
  //
  // Por eso hay que traer la config ANTES de decidir si se muestra: el evento de la
  // campaña sale de ahí. Antes se miraba la cookie primero y se usaba el id de la página.
  // VERSIÓN de la marca. Subirla invalida todas las cookies puestas hasta ahora y el
  // popup vuelve a ofrecerse a todos.
  //
  // Se subió a v2 porque hasta el 28/8 CERRAR el popup lo silenciaba por un año: mucha
  // gente lo cerró por reflejo, sin jugar, y quedó fuera de la ruleta de CALIENTE sin
  // saberlo. La cookie solo decide si el popup se muestra — NO toca los cupones, que
  // viven en roulette_plays y se resuelven por código. Nadie pierde lo que ganó.
  //
  // Quien YA jugó va a ver el popup de nuevo y el servidor le dirá "ya participaste por
  // este evento": es el precio de recuperar a los que nunca llegaron a jugar.
  const claveDe = (c) => `tk_ruleta_v2_${(c && c.eventId) || eventId}`;
  const yaJugo = (c) => document.cookie.includes(`${claveDe(c)}=1`);

  useEffect(() => {
    fetch(`${API}/api/public/roulette/${eventId}`).then(r => r.json()).then(c => {
      if (!c.active || !c.prizes?.length) return;
      // Solo se calla si YA JUGÓ. Cerrarla no la silencia: la persona entra a comprar y
      // muchas veces cierra por reflejo lo que se abre solo, sin registrar qué era.
      if (yaJugo(c)) return;
      setCfg(c);
      setTimeout(() => setOpen(true), 1200);
    }).catch(() => {});
  }, [eventId]); // eslint-disable-line

  // Se marca SOLO al jugar. Un año es de sobra: la campaña cambia cuando el dueño
  // vincula la ruleta a otro evento, y ahí cambia la clave.
  function marcarJugado() { document.cookie = `${claveDe(cfg)}=1; max-age=31536000; path=/`; }

  async function spin() {
    setError('');
    if (!/.+@.+\..+/.test(email) || phone.trim().length < 6) { setError('Ingresá un email y teléfono válidos'); return; }
    setSpinning(true);
    try {
      const r = await fetch(`${API}/api/public/roulette/spin`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ event_id: eventId, email, phone, marketing_consent: optin }),
      });
      const d = await r.json();
      if (!r.ok) { setError(d.error || 'No se pudo girar'); setSpinning(false); return; }
      // animación: ubicar el segmento ganador arriba
      const prizes = cfg.prizes;
      const idx = Math.max(0, prizes.findIndex(p => p.name === d.prize));
      const seg = 360 / prizes.length;
      const target = 360 * 5 - (idx * seg + seg / 2);
      setRot(target);
      setTimeout(() => { setResult(d); setSpinning(false); marcarJugado(); }, 3600);
    } catch { setError('Error de conexión'); setSpinning(false); }
  }

  // Cerrar solo cierra. Antes marcaba la cookie por un año, así que quien la cerraba
  // una vez —muchos, por reflejo— no la volvía a ver nunca y se perdía como participante.
  function close() { setOpen(false); }
  if (!open || !cfg) return null;
  const prizes = cfg.prizes;
  const seg = 360 / prizes.length;

  return (
    <div className="lb-modal-backdrop" onClick={close}>
      <div className="lb-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 420, textAlign: 'center', padding: '28px 26px' }}>
        <button className="lb-iconbtn" style={{ position: 'absolute', right: 16, top: 16 }} onClick={close}>✕</button>
        <div style={{ color: 'var(--red-400)', fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase' }}>— Solo esta noche —</div>
        {/* Para QUÉ evento sirve el cupón. Con varios eventos publicados, "ganaste un
            50%" no dice nada si no se aclara dónde se usa. */}
        {cfg.evento && (
          <div style={{ fontSize: 12.5, color: 'var(--ink-700)', marginTop: 8, lineHeight: 1.4 }}>
            Para <b style={{ color: '#fff' }}>{cfg.evento.name}</b>
            {cfg.evento.date && <span style={{ color: 'var(--ink-600)' }}> · {fmtDate(cfg.evento.date)}</span>}
          </div>
        )}
        <div className="lb-display" style={{ fontSize: 30, marginTop: 6 }}>Girá y <span style={{ color: 'var(--red-400)' }}>ganás.</span></div>

        <div style={{ margin: '22px auto', width: 240, height: 240, position: 'relative' }}>
          <svg viewBox="0 0 200 200" width="240" height="240" style={{ transform: `rotate(${rot}deg)`, transition: spinning || rot ? 'transform 3.5s cubic-bezier(0.17,0.67,0.2,1)' : 'none' }}>
            {prizes.map((p, i) => {
              const a0 = (i * seg - 90) * Math.PI / 180, a1 = ((i + 1) * seg - 90) * Math.PI / 180;
              const x0 = 100 + 95 * Math.cos(a0), y0 = 100 + 95 * Math.sin(a0);
              const x1 = 100 + 95 * Math.cos(a1), y1 = 100 + 95 * Math.sin(a1);
              const mid = (a0 + a1) / 2, tx = 100 + 58 * Math.cos(mid), ty = 100 + 58 * Math.sin(mid);
              return (
                <g key={i}>
                  <path d={`M100,100 L${x0},${y0} A95,95 0 ${seg > 180 ? 1 : 0} 1 ${x1},${y1} Z`} fill={SEG[i % SEG.length]} stroke="#000" strokeWidth="1" />
                  <text x={tx} y={ty} fill="#fff" fontSize="7" fontWeight="700" textAnchor="middle" transform={`rotate(${(i + 0.5) * seg},${tx},${ty})`}>{(p.name || '').slice(0, 11)}</text>
                </g>
              );
            })}
            <circle cx="100" cy="100" r="13" fill="#0A0A0A" stroke="#fff" strokeWidth="2" />
          </svg>
          <div style={{ position: 'absolute', top: -4, left: '50%', transform: 'translateX(-50%)', width: 0, height: 0, borderLeft: '9px solid transparent', borderRight: '9px solid transparent', borderTop: '16px solid #fff', zIndex: 2 }} />
        </div>

        {!result ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            <input className="lb-input" placeholder="Tu email" value={email} onChange={e => setEmail(e.target.value)} disabled={spinning} />
            <input className="lb-input" placeholder="Tu teléfono" value={phone} onChange={e => setPhone(e.target.value)} disabled={spinning} />
            <label style={{ display: 'flex', gap: 8, alignItems: 'flex-start', fontSize: 11, color: 'var(--ink-700)', textAlign: 'left', lineHeight: 1.45 }}>
              <input type="checkbox" checked={optin} onChange={e => setOptin(e.target.checked)} disabled={spinning} style={{ marginTop: 2 }} />
              <span>Soy mayor de 18 y quiero recibir novedades y promos por email. Podés darte de baja cuando quieras. <a href="/privacidad" target="_blank" rel="noreferrer" style={{ color: 'var(--red-400)' }}>Privacidad</a></span>
            </label>
            {error && <div className="lb-err">{error}</div>}
            <button className="lb-btn lb-btn--primary lb-btn--block" onClick={spin} disabled={spinning}>{spinning ? 'Girando…' : 'Girar la ruleta'}</button>
          </div>
        ) : (
          <div className="lb-fade">
            {result.isPrize ? (
              <>
                <div className="lb-h" style={{ fontSize: 22 }}>¡Ganaste {result.prize}!</div>
                {/* EL CUPÓN NO SE MUESTRA: llega por mail. Es lo que hace que la
                    dirección tenga que ser de verdad para poder cobrarlo. Si el envío
                    falló, se muestra acá igual — el premio ya está ganado. */}
                {result.enviado ? (
                  <div style={{ margin: '12px 0', padding: '14px', background: 'var(--ink-050)', border: '1px dashed var(--red-500)', borderRadius: 4 }}>
                    <div style={{ fontSize: 13, color: '#fff', lineHeight: 1.5 }}>
                      Te lo mandamos a <b>{result.email}</b>.
                    </div>
                    <div style={{ fontSize: 12, color: 'var(--ink-700)', marginTop: 6 }}>Revisá tu correo, y mirá también la carpeta de spam.</div>
                    {result.expiry && <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 6 }}>Vence el {new Date(result.expiry).toLocaleDateString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires' })}</div>}
                    <div style={{ marginTop: 10 }}>
                      {reenvio === 'ok'
                        ? <span style={{ fontSize: 12, color: '#2ecc71' }}>Te lo mandamos de nuevo ✓</span>
                        : <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={reenviar} disabled={reenvio === 'yendo'}>
                            {reenvio === 'yendo' ? 'Mandando…' : 'No me llegó'}
                          </button>}
                      {reenvio && reenvio !== 'ok' && reenvio !== 'yendo' && <div className="lb-err" style={{ marginTop: 6 }}>{reenvio}</div>}
                    </div>
                  </div>
                ) : (
                  <div style={{ margin: '12px 0', padding: '14px', background: 'var(--ink-050)', border: '1px dashed var(--red-500)', borderRadius: 4 }}>
                    <div style={{ fontSize: 11, color: 'var(--ink-600)', textTransform: 'uppercase', letterSpacing: '0.1em' }}>Tu cupón</div>
                    <div style={{ fontFamily: 'monospace', fontSize: 22, color: 'var(--red-400)', letterSpacing: '0.1em' }}>{result.coupon}</div>
                    <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 6 }}>No pudimos mandarte el mail: anotalo antes de cerrar.</div>
                    {result.expiry && <div style={{ fontSize: 11, color: 'var(--ink-600)', marginTop: 4 }}>Vence el {new Date(result.expiry).toLocaleDateString('es-AR', { timeZone: 'America/Argentina/Buenos_Aires' })}</div>}
                  </div>
                )}
                {/* El panel del comprador es el otro lugar donde el cupón está guardado:
                    si el mail se pierde, ahí sigue estando. */}
                {cfg?.slug && (
                  <div style={{ fontSize: 12, color: 'var(--ink-700)', lineHeight: 1.5, marginBottom: 12 }}>
                    Si tenés cuenta en la web, <a href={`/cuenta/${cfg.slug}`} style={{ color: 'var(--red-400)' }}>entrá</a> y vas a ver tus cupones junto con tus entradas. Si todavía no tenés, <a href={`/cuenta/${cfg.slug}`} style={{ color: 'var(--red-400)' }}>creala desde ahí</a>.
                  </div>
                )}
                {result.eventId && <a href={`/e/${result.eventId}`} className="lb-btn lb-btn--primary lb-btn--block">Comprar ahora →</a>}
              </>
            ) : (
              <>
                <div className="lb-h" style={{ fontSize: 20 }}>{result.prize}</div>
                <p style={{ color: 'var(--ink-700)', fontSize: 14 }}>¡Gracias por participar! La próxima puede ser tuya. Nos vemos en la pista. 🐺</p>
                <button className="lb-btn lb-btn--ghost lb-btn--block" onClick={close}>Cerrar</button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
